import {useEffect, useState} from "react";
import {customRound} from "../lib/customRound";

function useCurrencyConverter(sum, rate) {

    const [productTotal, setProductTotal] = useState('-');

    useEffect(() => {
        const currencySum = rate * sum;
        setProductTotal(customRound(rate > 0 ? currencySum : '-'));
    }, [sum, rate]);

    return productTotal;
}

export default useCurrencyConverter;
